import {gql} from '@apollo/client';

export const MODEL_PORTFOLIO_FRAGMENT = gql`
  fragment ModelPortfolioFragment on ModelPortfolioType {
    id
    isDeleted
    isDummy
    dateDeleted
    dateCreated
    dateUpdated
    curoId
    provider {
      id
      name
    }
    providerContact {
      id
      # range comes from here
      firstName
      lastName
      jobTitle
      isOptedIn
      isFavourite
      name
    }
    name
    imixModelCode
    riskProfile
    status
    investmentMandate
    performanceNarrative
    amcPortfolio
    ocfPortfolio
    commencedDate
  }
`;

export const LIST_MODEL_PORTFOLIOS = gql`
  query BuilderGetModelPortfolios(
    $potId: UUID
    $showPanel: Boolean
    $productId: UUID
    $providerId: UUID
    $accountId: UUID
    $isSppDa: Boolean!
    $parent: String
  ) {
    modelPortfolios(
      potId: $potId
      showPanel: $showPanel
      productId: $productId
      providerId: $providerId
      accountId: $accountId
      isSppDa: $isSppDa
      parent: $parent
    ) {
      ...ModelPortfolioFragment
    }
  }
  ${MODEL_PORTFOLIO_FRAGMENT}
`;
